export const EXPENSES_GROUP_LINKS = {
  BASE: `/app/expenses`,
  EXPENSES: `/app/expenses/expenses-list`,
  MILEAGES: `/app/expenses/mileages-list`,
};
